componentRegistryInstance.register('textarea', 'edit', 'hrd.components.form.TextAreaComponent');
componentRegistryInstance.register('textarea', 'read', 'hrd.components.form.TextAreaComponent');

hrd.components.form.TextAreaComponent = hrd.components.form.AbstractTextAreaComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.TextAreaComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	setReadOnlyField: function(field, value, object, options) {
		var asHtml = field.data('asHtml');
		if (asHtml) {
			field.html(value);
		} else {
			field.text(value);
		}
	},
	initalizeComponent: function(field, initialValue) {
		// do nothing: do not call 'super'
	},
	resetEditableField: function(field, options) {
		field.val('');
		let id = this.getFieldId();
		let maxLength = this.utils().getMaxLength(field);
		if (maxLength) {
			var counter = $(`#${id}-counter`);
			counter.html(this.utils().createCharCounterMessage(0, maxLength));
		}
	}
});